export function shouldCalculateAppPath(currentAppPath, getBoundariesFullData) {
    return !!currentAppPath || !getBoundariesFullData;
}
